import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import Vial from './Vial.js';

export default class Vials extends AContainer
{
    constructor(scene, colors, amounts)
    {
        super(scene);

        this.vials = [];
        this.zones = [];
        this.colors = colors;
        this.amounts = amounts;

        this.createVials();
        this.tweenInVials();
    }

    createVials()
    {
        for (let i=0; i<5; i++)
        {
            let vial = new Vial(this.scene, 325 + (i*100), -200, i, this.colors[i], this.amounts[i]);
            this.vials.push(vial);
        }

        if(gameData.customFuzzbug) 
        {
            let rand = Phaser.Math.Between(0, this.vials.length-1)
            this.vials[rand].setCustom();
        }
    }

    getMax() {
        if(!this.questionsHigh) {
            this.questionsHigh = [];

            this.vials.forEach((vial)=>{
                if(vial.amount > 3) this.questionsHigh.push(vial.amount);
            });
        }        

        let randInd = Phaser.Math.Between(0, this.questionsHigh.length-1);
        let highAmount = this.questionsHigh[randInd];
        this.questionsHigh.splice(randInd, 1);

        let highVial;
        this.vials.forEach((vial)=>{
            if(vial.amount === highAmount) highVial = vial;
        });

        return highVial;
    }

    getMin(max) {
        let lowCount = [];
        let maxAdj = max-1;
        this.vials.forEach((vial)=>{
            if(vial.amount < maxAdj) lowCount.push(vial.amount);
        });

        let rand = lowCount[Phaser.Math.Between(0, lowCount.length-1)];
        let lowVial;
        this.vials.forEach((vial)=>{
            if(vial.amount === rand) lowVial = vial;
        });

        return lowVial;
    }

    getCustomVial()
    {
        this.vials.forEach((vial)=>{
            if(vial.isCustom) return vial;
        });
    }

    tweenInVials()
    {
        this.vials.forEach((vial)=>{
            vial.vials.forEach((innerVial)=>{
                this.scene.addTween(innerVial, 1000, {y:this.scene.mid.y - 25, delay:100*vial.ind}, Phaser.Math.Easing.Quadratic.Out);
            });
        });
    }

    tweenOutVials()
    {
        this.vials.forEach((vial)=>{
            vial.vials.forEach((innerVial)=>{
                this.scene.addTween(innerVial, 1000, {x:-500 + (vial.ind*90)}, Phaser.Math.Easing.Quadratic.In);
            });
        });
    }

    bunchVials()
    {
        this.vials.forEach((vial)=>{
            vial.vials.forEach((innerVial)=>{
                this.scene.addTween(innerVial, 1500, {x:125 + (vial.ind*90), delay:100*vial.ind}, Phaser.Math.Easing.Back.Out);
            });
        });
    }

    cleanUp()
    {
        //console.log("cleaning UP");
       this.vials.forEach((vial)=>{
           vial.cleanUp();
           vial.destroy();
        });

       this.vials = [];
    }
}